import { Card, Flex, Text } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

interface ISimpleIconCard {
  label: string;
  description: string;
  icon: ReactNode;
}

export const SimpleIconCard: FC<ISimpleIconCard> = ({ label, description, icon }) => {
  return (
    <Card
      maxW={{ base: '378px', sm: '336px', lg: '288px' }}
      h={{ base: '96px', sm: '112px', lg: '218px' }}
      w="100%"
      flexDirection={{ base: 'row', lg: 'column' }}
      variant="filled"
      alignItems={{ base: 'flex-start', lg: 'center' }}
      justifyContent={{ base: 'flex-start', lg: 'center' }}
      p={{ base: 5, lg: 7 }}
      borderRadius={8}
    >
      <Flex
        mr={{ base: 6, lg: 0 }}
        flexShrink={0}
        borderRadius={8}
        justifyContent="center"
        alignItems="center"
        backgroundColor="violet.50"
        w={14}
        h={14}
      >
        {icon}
      </Flex>
      <Flex textAlign={{ base: 'left', lg: 'center' }} flexDirection={{ base: 'column' }}>
        <Text fontFamily="heading" fontSize={{ base: 'md', lg: 'lg' }} fontWeight="bold" mt={{ base: 0, lg: 6 }}>
          {label}
        </Text>
        <Text px={{ base: 0, lg: 3 }} fontSize={{ base: 'xs', sm: 'sm', md: 'md' }} mt={2}>
          {description}
        </Text>
      </Flex>
    </Card>
  );
};
